// TODO: credential management api (save user/pass, save provider, auto sign-in, auto user/pass fill)
// - assetlinks (between domains)
// - unmediated: true, mediation: 'silent'
// - smartlock https://developers.google.com/identity/

import { PolymerElement } from '@polymer/polymer/polymer-element.js';
import { Localizer } from '../extendibles/Localizer.js';
import '@polymer/paper-input/paper-input.js';
import '@polymer/paper-button/paper-button.js';

import { session } from '../../app/session.js';
import { defineElement } from '../../utility/defineElement.js';
import { api } from '../../api/api.js';
import { log } from '../../app/log.js';
import { config } from '../../app/config.js';
import * as tools from '../../utility/tools.js';

import { template } from './lag-signin.html.js';

defineElement(class extends Localizer(PolymerElement) {

    static get is() { return 'lag-signin'; }

    static get template() { return template; }

    static get properties() {
        return {
            admin: {
                type: Boolean,
                value: false
            },

            urlIdpReturn: {
                type: String,
                value: '/' // Default returnurl is just root.
            },

            urlSigninRecover: {
                type: String,
                value: '/signin-recover'
            },
            urlSigninCreate: {
                type: String,
                value: '/signin-create'
            }
        };
    }

    ready() {
        super.ready();

        session.signOut();

        this._applyParams();

        // TODO: AutoComplete for saving user/pass
        // https://developers.google.com/web/fundamentals/design-and-ui/input/forms/#label_and_name_inputs_properly
        // https://stackoverflow.com/questions/2382329/how-can-i-get-browser-to-prompt-to-save-password
        // https://medium.com/dev-channel/sign-in-on-the-web-credential-management-api-and-best-practices-d21aed14b6fe
        // Credential Management API would work in modern Chrome (and should also be done) but not good for fallback when the API isnt available (most browsers).
        // I tried adding 'autocomplete' attributes to paper-input and contained the fields + buttons in a <form> and theform.dispatchEvent(new Event('submit'))
        // but browsers didnt save the password. Not sure what I was doing wrong.
    }

    _applyParams() {
        this._applyParams_Status(tools.url.getParam('status'));

        this._applyParams_TransferToken(
            parseInt(tools.url.getParam('u'), 10),
            tools.url.getParam('t'));
    }
    _applyParams_Status(status) {
        if (!status || !status.length)
            return;

        if (status.match(/failure-idp-[a-z]+/)) {
            this._signInError('signin.errors.idpFailure');
        }
    }
    _applyParams_TransferToken(userId, transferToken) {
        if (userId <= 0 || !transferToken || !transferToken.length)
            return;

        this._submitTransferToken(userId, transferToken);
    }

    _submitTransferToken(userId, transferToken) {
        this._clearSignInError();

        // If admin:true then call signInAdmin, else call signIn;
        // both will return a Promise of the same form.
        session.signInTransferToken(userId, transferToken)
            .then(this._handleSignInResponse.bind(this, 'signin.errors.idpFailure'))
            .catch(this._handleSignInException.bind(this, 'signin.errors.idpException'));
    }

    _submitIdpSignIn(ev) {
        const provider = ev.currentTarget.dataset['idp'];
        // Go to provider prompt (will redirect back to idp returnurl after done).
        location.href = config.endpoints.authAPI + `idp/${provider}/prompt?site=${config.siteId}&returnurl=${encodeURIComponent(this.urlIdpReturn)}`;
    }

    /**
     * @deprecated made obsolete by adding the form tags.
     */
    _ksubmitSignIn(e) {
        // On enter key.
        if ((e.which || e.keyCode) === 13) {
            this._submitSignIn();
        }
    }

    _submitSignIn() {
        this._clearSignInError();

        const username = this.$.username.value,
            password = this.$.password.value;

        // If admin:true then call signInAdmin, else call signIn;
        // both will return a Promise of the same form.
        (this.admin
            ? session.signInAdmin(username, password)
            : session.signIn(username, password)
        )
            .then(result => { this._handleSignInResponse('signin.errors.invalid', result); })
            .catch(ex => { this._handleSignInException('signin.errors.tooShort', ex); });
    }

    _handleSignInResponse(errorMessageLookup, result) {
        if (result.ok) {
            this._clearSignInError();
            this._clearSignInFields(true); // Success, don't need these fields filled anymore, clear fields so user/pass not lying around.

            this._close(true);
        }
        else {
            if (result.data === 'needs-confirmation') {
                this._signInError('signin.errors.confirmationNeeded');

                api.post('account/confirm/email', { User: this.$.username.value, Pass: this.$.password.value }).then(result => {
                    if (!result.ok) {
                        log.error('lag-signin._handleSignInResponse{confirm/email}', result);
                        this._signInError('signin.errors.confirmationError');
                    }
                });
            }
            else if (result.data === 'invalid-ipaddress')
                this._signInError('signin.errors.invalidIPaddress');
            else this._signInError(errorMessageLookup);

            // Clear password for security, probably invalid anyway, don't clear username since that can be a bother to user when they want to retry.
            this._clearSignInFields(false);
        }
    }

    _handleSignInException(errorMessageLookup, ex) {
        if (ex instanceof api.auth.exceptions.ArgumentsInvalidException) {
            // Clear password for security, and it's invalid, don't clear username since that can be a bother to user when they want to retry.
            this._clearSignInFields(false);

            this._signInError(errorMessageLookup);
        }
        else { // UnexpectedException
            this._clearSignInFields(true);

            this._signInError('signin.errors.unknown');
        }
    }

    _close(success) {
        this._clearSignInError();

        this.dispatchEvent(new CustomEvent('done', { detail: success }));
    }

    _signInError(errorMessageLookup) {
        if (!errorMessageLookup)
            this.$.error.innerText = '';
        else
            this.$.error.innerText = this.localize(errorMessageLookup);
    }
    _clearSignInError() {
        this._signInError();
    }

    _clearSignInFields(clearUsername) {
        if (clearUsername) {
            this.$.username.value = '';
        }

        // Always clear password.
        this.$.password.value = '';
    }

});